{
    "Profile_Vehicles_Vehicle.vehicleDetails": "FR: Vehicle Details",
    "Profile_Vehicles_Vehicle.number": "FR: Number",
    "Profile_Vehicles_Vehicle.year": "FR: Year",
    "Profile_Vehicles_Vehicle.make": "FR: Make",
    "Profile_Vehicles_Vehicle.model": "FR: Model",
    "Profile_Vehicles_Vehicle.vicc": "FR: VICC",
    "Profile_Vehicles_Vehicle.vin": "FR: VIN",
    "Profile_Vehicles_Vehicle.additionalAlarm": "FR: Additional Alarm",
    "Profile_Vehicles_Vehicle.engravings": "FR: Engravings",
    "Profile_Vehicles_Vehicle.tracking": "FR: Tracking",
    "Profile_Vehicles_Vehicle.garageType": "FR: Garage Type",
    "Profile_Vehicles_Vehicle.garagedAtInsuredAddress": "FR: Garaged at Insured Address",
    "Profile_Vehicles_Vehicle.garagingAddress": "FR: Garaging Address",
    "Profile_Vehicles_Vehicle.ownershipDetails": "FR: Ownership Details",
    "Profile_Vehicles_Vehicle.owned": "FR: Owned",
    "Profile_Vehicles_Vehicle.lessor": "FR: Lessor",
    "Profile_Vehicles_Vehicle.financed": "FR: Financed",
    "Profile_Vehicles_Vehicle.financerLender": "FR: Financer Lender",
    "Profile_Vehicles_Vehicle.financeRate": "FR: Finance Rate",
    "Profile_Vehicles_Vehicle.purchasedUsed": "FR: Purchased Used",
    "Profile_Vehicles_Vehicle.purchaseDate": "FR: Purchase Date",
    "Profile_Vehicles_Vehicle.purchaseValue": "FR: Purchase Value",
    "Profile_Vehicles_Vehicle.currentValue": "FR: Current Value",
    "Profile_Vehicles_Vehicle.newValue": "FR: New Value",
    "Profile_Vehicles_Vehicle.usageDetails": "FR: Usage Details",
    "Profile_Vehicles_Vehicle.leisureActivity": "FR: Leisure Activity",
    "Profile_Vehicles_Vehicle.dailyCommute": "FR: Daily Commute",
    "Profile_Vehicles_Vehicle.businessActivity": "FR: Business Activity",
    "Profile_Vehicles_Vehicle.rideshare": "FR: Rideshare",
    "Profile_Vehicles_Vehicle.winterTires": "FR: Winter Tires",
    "Profile_Vehicles_Vehicle.storedForWinter": "FR: Stored for winter",
    "Profile_Vehicles_Vehicle.storageStart": "FR: Storage Start",
    "Profile_Vehicles_Vehicle.storageEnd": "FR: Storage End",
    "Profile_Vehicles_Vehicle.vehicleUsage": "FR: Vehicle Usage",
    "Profile_Vehicles_Vehicle.newUsage": "FR: New Usage"
}
